import React, { useEffect } from 'react'
import MapWithContactInfo from '../components/MapWithContactInfo/MapWithContactInfo'
import WelcomeKontakt from '../components/WelcomeKontakt/WelcomeKontakt'
import ZnanyLekaz from '../components/ZnanyLekaz/ZnanyLekaz'
import KontaktInfo from "../components/KontaktInfo/KontaktInfo";

const Kontakt = () => {
	useEffect(() => {
		window.scrollTo({
			top: 0,
		})
	}, [])

	return (
		<>
			<WelcomeKontakt />
			<KontaktInfo />
			<ZnanyLekaz />
			<MapWithContactInfo />
		</>
	)
}

export default Kontakt
